<template>
    <div>
        <div class="no-data" v-if="!deliveriesLength">Your delivery orders will appear here</div>
        <v-data-table v-else :headers="headers" :items="filteredItems" :items-per-page="50" hide-default-footer fixed-header class="default-table">
            <template v-slot:item="{ item }">
                <tr>
                    <td v-on:click="() => { openDeliveryDetails(item) }">
                        <div class="hyperlink-td">
                            {{item.id}}
                            <div class="link-border"></div>
                        </div>
                    </td>
                    <td>
                        {{item.name}}
                    </td>
                    <td>
                        {{item.email}}
                    </td>
                    <td>
                        {{item.date}}
                    </td>
                    <td>
                        {{item.sogenId}}
                    </td>
                    <td class="text-right">
                        {{item.total}}
                    </td>
                </tr>
            </template>
       </v-data-table>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {AOrders} from '@/store/actions';
    import { GOrders } from '@/store/getters';

    export default {
        name: "DeliveryOrders",
        data() {
            return {
                orderMatchId: null,
                headers: [
                    { text: 'Invoice No.', value: 'id', class: 'invoiceNumber-th' },
                    { text: 'Invoice name', value: 'name' },
                    { text: 'Invoice email', value: 'email' },
                    { text: 'Date', value: 'date' },
                    { text: 'Sogen ID', value: 'sogenId' },
                    { text: 'Total incl. VAT', align: 'right', value: 'total' }
                ]
            };
        },
        computed: {
            ...mapGetters({
                deliveriesList: GOrders.GET_DELIVERIES,
                deliveriesLength: GOrders.GET_DELIVERIES_LENGTH
            }),
            filteredItems(){
                let updatedListItems = [];

                this.deliveriesList.forEach(item => {
                    let invoiceItem = {};
                    // invoiceItem.id = item.invoiceNumber;
                    // invoiceItem.date = moment(item.createdOn).format('DD MMMM YYYY');
                    // invoiceItem.name = item.invoiceName;
                    // invoiceItem.total = '€ ' + item.invoiceTotalAmount.toLocaleString("fi-FI", { minimumFractionDigits: 2 }).replace(',','.');
                    // invoiceItem.sogenId = item.sogenId;
                    // invoiceItem.email = item.email;
                    // updatedListItems.push(invoiceItem);
                });

                return updatedListItems;
            }
        },
        methods: {
            openDeliveryDetails(id) {
                this.$store.dispatch(AOrders.GET_DELIVERY_DETAILS, id).then(() => {
                    this.navigation.navigate('DeliveryOrderDetails');
                })
            }
        },
        created () {
            this.$store.dispatch(AOrders.GET_DELIVERIES)
        }
    }
</script>

<style scoped>
    .wine-name {
        font-weight: 400;
    }
    .case-size-info {
        color: #B2B2B2;
        font-size: var(--fs-small);
        font-weight: 300;
    }
</style>
